import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
  withViewTransitions,
} from '@angular/router';

import { routes } from '../app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from '../data/interceptors/auth.interceptor';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { environment } from '../../environments/environment';
import { provideCountdown } from 'ngx-countdown';
import { registerLocaleData } from '@angular/common';
import localeEsCo from '@angular/common/locales/es-CO';
import { DataModule } from '../data/data.module';

registerLocaleData(localeEsCo);

const config: SocketIoConfig = {
  url: environment.nodeUrl,
  options: {
    transports: ['websocket'],
    reconnection: true,
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      DataModule,
      SocketIoModule.forRoot(config)
    ),

    provideRouter(
      routes,
      withViewTransitions(),
      withPreloading(PreloadAllModules)
    ),

    provideClientHydration(),
    provideCountdown({ format: `mm:ss` }),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor])
    ),
    provideAnimations(),
  ],
};